import {HttpService} from "@/services/http.services";
import { CONSTANT_CONFIG } from "@/constants";
import {AxiosPromise} from "axios";

const API_BASE = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/employee-join`;

class EmployeeJoinApi {
    list(params: any): AxiosPromise {
        return HttpService.get(API_BASE, params);
    }
    getById(id: string): AxiosPromise {
        return HttpService.get(`${API_BASE}/${id}`);
    }
    create(payload: any): AxiosPromise {
        return HttpService.post(API_BASE, payload);
    }
    update(id: string, payload: any): AxiosPromise {
        return HttpService.put(`${API_BASE}/${id}`, payload);
    }
    delete(id: string): AxiosPromise {
        return HttpService.delete(`${API_BASE}/${id}`);
    }
    bulk(payload: any): AxiosPromise {
        return HttpService.post(`${API_BASE}/bulk`, payload);
    }
    dropdown(params: any): AxiosPromise {
        return HttpService.get(`${API_BASE}/dropdown`, {params});
    }
}

export default EmployeeJoinApi;
